import { combineReducers, type Reducer, type ReducersMapObject } from 'redux';

import { MODULE_NAME } from '../../constants';

import { reducer as attachmentsReducer, State as AttachmentsState } from './attachments';
import { reducer as blockedUsersReducer, State as BlockedUsersState } from './blocked.users';
import { reducer as commentsReducer, State as CommentsState } from './comments';
import { reducer as commonReducer, State as CommonState } from './common';

export interface State {
    comments: CommentsState;
    common: CommonState;
    attachments: AttachmentsState;
    blockedUsers: BlockedUsersState;
}

const reducers: ReducersMapObject<State> = {
    comments: commentsReducer,
    common: commonReducer,
    attachments: attachmentsReducer,
    blockedUsers: blockedUsersReducer,
};

export const reducer: Reducer<State> = combineReducers(reducers);

export const getState = (state: { [MODULE_NAME]: State }) => state[MODULE_NAME];
